import React from "react"

const CardFooter = ({ price }) => {
    return (
    <div className="card-footer bg-primary">
        <h2>{`R$${price},00`}</h2>
    </div>
    )
}

export default CardFooter;